module.exports = __webpack_public_path__ + "img/img_platform_name_c.332912c7.png";